module.exports = __webpack_public_path__ + "static/media/mrtk.d90fad33.jpg";